import { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { blue } from '@material-ui/core/colors'
import styles from './EditGroupForm.module.scss'
import { withLocalize } from 'react-localize-redux'
import { TextField, Typography } from '@material-ui/core'
import Button from 'common/components/Button/Button'

import cx from 'classnames'

import SearchOutlinedIcon from '@material-ui/icons/SearchOutlined'
import PropTypes from 'prop-types'
import { DeviceSelector } from 'modules/modals/NewModals/Components/Molecules/DevicesSelector/DevicesSelector'
import { NoGroupSelector } from 'modules/modals/NewModals/Components/Molecules/NoGroupSelector/NoGroupSelector'
import { useForm } from 'react-hook-form'
import { Tooltip } from '@mui/material'

const useStyles = makeStyles(() => ({
  input: {
    [`& fieldset`]: {
      borderRadius: 30,
      borderColor: 'grey'
    },
    '& label.Mui-focused': {
      color: blue[600]
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: 'grey'
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: 'grey'
      },
      '&:hover fieldset': {
        borderColor: 'grey'
      },
      '&.Mui-focused fieldset': {
        borderColor: blue[600]
      }
    }
  }
}))

const EditGroupForm = props => {
  const { register, errors, setError, clearErrors } = useForm()
  const classes = useStyles()

  const { translate, allSystems, editingGroup, isSubmitting, onSubmit } = props

  const allGroupSystems = allSystems.filter(system => system.group === editingGroup)

  const [groupName, setGroupName] = useState(editingGroup)
  const [filterExpression, setFilterExpression] = useState('')
  const [selectedGroupCheckboxIds, setSelectedGroupCheckboxIds] = useState([])
  const [selectedProjectCheckboxIds, setSelectedProjectCheboxIds] = useState([])
  const [groupSystems, setGroupSystems] = useState(allGroupSystems)
  const [initialAllGroupSystems, setInitialAllGroupSystems] = useState([])

  const handleFilterExpressionChange = event => {
    setFilterExpression(event.target.value)
  }

  const handleChangeGroupDevice = selectedCheckboxIds => {
    setSelectedGroupCheckboxIds(selectedCheckboxIds)
  }
  const handleChangeProjectDevice = selectedCheckboxIds => {
    setSelectedProjectCheboxIds(selectedCheckboxIds)
  }

  const onClickRemoveDevices = () => {
    setGroupSystems(prevSystems =>
      prevSystems.filter(system => !selectedGroupCheckboxIds.includes(system._id))
    )

    allSystems.forEach(system => {
      if (selectedGroupCheckboxIds.includes(system._id)) {
        system.group = undefined
      }
    })

    setSelectedGroupCheckboxIds([])
  }

  const onClickAddDevices = () => {
    const devicesToAdd = allSystems.filter(system =>
      selectedProjectCheckboxIds.includes(system._id)
    )
    setGroupSystems(prevSystems => [...prevSystems, ...devicesToAdd])
    setSelectedProjectCheboxIds([])
    checkGroupSystems([...groupSystems, ...devicesToAdd].map(item => item._id))
  }

  let groupSystemsJS =
    filterExpression !== ''
      ? groupSystems.filter(s => s.name.toLowerCase().includes(filterExpression.toLowerCase()))
      : groupSystems

  let projectSystemsJS = allSystems.filter(s => {
    const isInGroup = groupSystemsJS.some(p => p._id === s._id)
    if (filterExpression !== '') {
      return !isInGroup && s.name.toLowerCase().includes(filterExpression.toLowerCase())
    }
    return !isInGroup
  })
  const checkGroupName = groupName => {
    if (groupName === '' || groupName === undefined) {
      setError('groupName', { shouldFocus: 'groupName' })
    } else {
      clearErrors('groupName')
    }
  }
  const editGroupName = groupName => {
    checkGroupName(groupName)
    setGroupName(groupName)
  }

  const checkGroupSystems = groupSystems => {
    if (groupSystems.length === 0) {
      setError('groupSystems', { shouldFocus: 'groupSystems' })
    } else {
      clearErrors('groupSystems')
    }
  }

  const onSaveForm = () => {
    const jsonData = {}
    const initialGroupDevicesIds = initialAllGroupSystems.map(item => item._id)
    jsonData.deviceIds = groupSystems.map(item => item._id)
    jsonData.noGroupDeviceIds = initialGroupDevicesIds.filter(
      id => !jsonData.deviceIds.includes(id)
    )
    jsonData.group = groupName
    checkGroupName(groupName)
    checkGroupSystems(jsonData.deviceIds)
    if (!errors.groupName && !errors.groupSystems) {
      onSubmit(jsonData)
    }
  }
  const onClickCancel = () => {
    props.hideModal()
  }
  useEffect(() => {
    setInitialAllGroupSystems(allGroupSystems)
  }, [])

  return (
    <div className={styles.modalContainer}>
      <Typography className={styles.header}>{translate('editGroup')}</Typography>
      <div className={styles.modal}>
        <form
          noValidate
          onKeyDown={ev => {
            if (ev.key === 'Enter') {
              ev.preventDefault()
            }
          }}
        >
          <TextField
            variant='outlined'
            required
            fullWidth
            id='groupName'
            label={translate('groupName')}
            inputRef={register({ required: true })}
            name='groupName'
            value={groupName}
            onChange={event => editGroupName(event.target.value)}
            helperText={`${groupName.length}/36`}
            inputProps={{ maxLength: 36 }}
            className={cx(styles.input, classes.input, {
              [styles.hasError]: errors.name
            })}
          />
          {errors.groupName && (
            <div className={styles.error}>
              <small>{translate('validation.required')}</small>
            </div>
          )}
          <div className={styles.searchDeviceInput}>
            <SearchOutlinedIcon />
            <input
              type='text'
              id='searchDevice'
              name='searchDevice'
              placeholder={translate('searchDevice')}
              onChange={handleFilterExpressionChange}
              value={filterExpression}
            />
          </div>

          <div
            className={styles.devicesList}
            id='devicesList'
          >
            <div className={styles.newGroupContainer}>
              <NoGroupSelector
                systems={groupSystemsJS}
                selectedCheckboxIds={selectedGroupCheckboxIds}
                setSelectedCheckboxIds={handleChangeGroupDevice}
                translate={translate}
                userWriting={filterExpression.length > 0}
                checkboxColor='#f53152'
              />
            </div>
            {errors.groupSystems && (
              <div className={styles.error}>
                <small>{translate('validation.atLeastOneDevice')}</small>
              </div>
            )}
            {groupSystemsJS.length > 0 && (
              <div className={styles.listButtonWrapper}>
                <Button
                  type='light-delete'
                  label={translate('removeDevices')}
                  onClick={onClickRemoveDevices}
                />
              </div>
            )}
          </div>

          <div
            className={styles.devicesList}
            id='devicesList'
          >
            <div className={styles.newGroupContainer}>
              <span className={styles.deviceListTitle}>
                {translate('editGroupForm.selectDevices')}
              </span>

              <DeviceSelector
                systems={projectSystemsJS}
                selectedCheckboxIds={selectedProjectCheckboxIds}
                setSelectedCheckboxIds={handleChangeProjectDevice}
                translate={translate}
                userWritting={filterExpression.length > 0}
              />
            </div>
            {projectSystemsJS.length > 0 && (
              <div className={styles.listButtonWrapper}>
                <Button
                  type='add'
                  label={translate('addDevices')}
                  onClick={onClickAddDevices}
                />
              </div>
            )}
          </div>
          <div className={styles.buttonWrapper}>
            {selectedProjectCheckboxIds.length > 0 || selectedGroupCheckboxIds.length > 0 ? (
              <Tooltip
                placement='top-start'
                enterDelay={100}
                leaveDelay={200}
                title={translate('saveSelectedAddRemove')}
              >
                <div>
                  <Button
                    disabled
                    type='next'
                    label={translate('save')}
                    onClick={onSaveForm}
                  />
                </div>
              </Tooltip>
            ) : (
              <Button
                isLoading={isSubmitting}
                type='next'
                label={translate('save')}
                onClick={onSaveForm}
              />
            )}
          </div>
          <div className={styles.buttonWrapper}>
            <Button
              type='cancel'
              isLoading={isSubmitting}
              onClick={onClickCancel}
              label={translate('cancel')}
            />
          </div>
        </form>
      </div>
    </div>
  )
}

EditGroupForm.propTypes = {
  translate: PropTypes.func.isRequired
}

export default withLocalize(EditGroupForm)
